// Material UI
import { makeStyles } from '@material-ui/styles';
// Consts
import { neutral, purple } from 'shared/styles/colors';

export default makeStyles(theme => ({
  root: {
    backgroundColor: purple[10],
    color: neutral[80],
  },
  content: {
    fontFamily: 'PP Object Sans',
  },
}));
